@if (lorenzFormControl && lorenzFormGroup) {

	<div class="outer-wrapper"
		 [formGroup]="lorenzFormGroup">

		<div class="control-wrapper">

			<input type="{{ type }}"
				   [formControl]="lorenzFormControl"

				   class="control"
				   [ngClass]="{
						'readonly': lorenzFormControl.isBlocked(),
						'missing-required': lorenzFormControl.isMissingRequiredValue(),
						'no-label': !lorenzFormControl.hasLabel(),
						'highlighted': lorenzFormControl.isHighlighted()
				   }"

				   [attr.readonly]="lorenzFormControl.isBlocked() ? true : null"
			>

			@if (isLayoutFloatingLabels && lorenzFormControl.hasLabel()) {
				<label class="floating-label"
					   [innerHTML]="(lorenzFormControl.getLabel() | translate) + lorenzFormControl.getRequiredAsterisk()">
				</label>
			}

			@if (lorenzFormControl.hasText()) {
				<div class="text"
					 [innerHTML]="lorenzFormControl.getText()">
				</div>
			}

			<lib-form-validity-dot [control]="lorenzFormControl" />

		</div>

		@if (showErrorMessages) {
			<div class="error">{{ lorenzFormControl.getErrors() | translate }}</div>
		}

	</div>

}
